var map = {
	"./alert.png": "65a5",
	"./edit-date.png": "bf9a",
	"./edit-note.png": "8525",
	"./edit-oven_props.png": "e6ae",
	"./edit-transport.png": "75ab",
	"./packing-1.png": "5209",
	"./packing-2.png": "6916",
	"./packing-3.png": "5af8",
	"./packing-4.png": "e017",
	"./trasporto.png": "ca7e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a451";